import { styled } from '@mui/material/styles';
import React, { useContext, useState } from 'react';
import { Link } from 'react-router-dom';
import {
  GlobalFeatureNameSpaceNotary,
  useDispatch
} from '../../common/redux.Interface.Component';
import { createAction } from '../../common/redux.Interface.Reducer';
import {
  checkSession,
  establishOrRefreshSession
} from '../../common/sessionGate';
import { GlobalContext } from '../../services/context/DataContext';
import { data } from '../../services/mockingData/User';
import { isAllowedToAccessAdminDashboard } from '../../services/permissions/permissionHelper';
import { removeAllItemsInSessionStorage } from '../../services/util/sessionStorageManager';
import CountBadge from '../1elements/CountBadge';
import AdminIcon from '../1elements/Icons/js/icons/AdminIcon';
import LogOutIcon from '../1elements/Icons/js/icons/LogOutIcon';
import ITooltip from '../1elements/ITooltip';
import { InitialAvatar } from '../1elements';
import Text from '../1elements/Text';
import IMenu from '../2compounds/IMenu';

const menuActionStyles = {
  textDecoration: 'none !important',
  display: 'flex',
  alignItems: 'center',
  width: '100%',
  padding: 0,
  border: 'none',
  background: 'none',
  cursor: 'pointer'
};

const UserAvatar = styled(InitialAvatar)(({ theme }) => ({
  cursor: 'pointer',
  objectFit: 'scale-down',
  boxShadow: '0 0 6px #00000040',
  backgroundColor: theme.palette.secondary.accent,
  color: '#fff',
  borderRadius: '50%'
}));

const AdminLink = styled(Link, {
  shouldForwardProp: (prop) => prop !== 'disabled'
})(({ disabled }) => ({
  ...menuActionStyles,
  ...(disabled && {
    pointerEvents: 'none',
    opacity: 0.5
  })
}));

const SignOutButton = styled('button')(menuActionStyles);

const MenuIcon = styled('div')({
  width: 40,
  marginRight: 5,
  display: 'flex',
  alignItems: 'center',

  '& svg': {
    width: 30,
    maxHeight: 24
  }
});

const MenuCountBadge = styled(CountBadge)({
  alignItems: 'center',

  '& .MuiBadge-badge': {
    position: 'relative',
    transform: 'none',
    marginLeft: 5
  }
});

export default function UserMenu() {
  checkSession();
  const accessToAdminDashboardPermission = isAllowedToAccessAdminDashboard();
  const [anchorEl, setAnchorEl] = useState(null);
  const {
    dataManagementNotificationCount: dataManagementNotificationCountContext
  } = useContext(GlobalContext);
  const [dataManagementNotificationCount] =
    dataManagementNotificationCountContext;

  const name = localStorage.getItem('username');
  const email = localStorage.getItem('email');

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    establishOrRefreshSession();
  };

  const handleClose = () => {
    setAnchorEl(null);
    removeAllItemsInSessionStorage();
    establishOrRefreshSession();
  };

  const open = Boolean(anchorEl);

  const dispatch = useDispatch();
  const doDispatch = () => {
    dispatch(
      createAction(GlobalFeatureNameSpaceNotary.SIGNIN_SIGNOUT, 'signOut')()
    );
  };

  return (
    <div>
      <CountBadge
        count={open ? 0 : dataManagementNotificationCount}
        overlap="circular"
      >
        <ITooltip content={data.name} placement="right" arrow>
          <UserAvatar onClick={handleClick} userName={name} email={email} />
        </ITooltip>
      </CountBadge>

      <IMenu
        position="left_center"
        type="text"
        anchorEl={anchorEl}
        open={open}
        handleClose={handleClose}
      >
        <AdminLink
          to="/adminDashboard"
          disabled={!accessToAdminDashboardPermission}
          onClick={handleClose}
        >
          <MenuCountBadge count={dataManagementNotificationCount}>
            <MenuIcon>
              <AdminIcon />
            </MenuIcon>
            <Text type="mendoDispatchuItem">Admin</Text>
          </MenuCountBadge>
        </AdminLink>

        <SignOutButton onClick={doDispatch}>
          <MenuIcon>
            <LogOutIcon />
          </MenuIcon>
          <Text type="logoutText">Sign out</Text>
        </SignOutButton>
      </IMenu>
    </div>
  );
}
